import React, { useState, useEffect } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Inject,
} from "@syncfusion/ej2-react-grids";
import { Header } from "../Components";
import axios from "axios";
import {
  FaSearch,
  FaTrash,
  FaTimes,
  FaFileExcel,
  FaFilePdf,
  FaPlus,
  FaEdit,
} from "react-icons/fa";
import { useBaseUrl } from "../Contexts/BaseUrlContext";
import { useStateContext } from "../Contexts/ContextProvider";
// Grid column configuration
const testimonialGrid = [
  {
    field: "id",
    headerText: "ID",
    width: 80,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">ID</span>,
  },
  {
    field: "name",
    headerText: "Name",
    width: 150,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Name</span>,
  },
  {
    field: "message",
    headerText: "Message",
    width: 200,
    textAlign: "Left",
    allowFiltering: true,
    headerTemplate: () => <span className="font-bold">Message</span>,
  },
  {
    field: "image",
    headerText: "Image",
    width: 100,
    textAlign: "Center",
    template: (props) => (
      <img
        src={props.image_url}
        alt="Testimonial"
        className="w-12 h-12 object-cover rounded-full"
      />
    ),
    headerTemplate: () => <span className="font-bold">Image</span>,
  },
  {
    field: "designation",
    headerText: "Designation",
    width: 150,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Designation</span>,
  },
  {
    field: "Actions",
    headerText: "Actions",
    width: 120,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Actions</span>,
    template: (props) => (
      <div className="flex justify-center gap-3">
        <button
          className="text-blue-600 hover:text-blue-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.editHandler(props)}
          title="Edit"
        >
          <FaEdit size={18} />
        </button>
        <button
          className="text-red-600 hover:text-red-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.deleteHandler(props.id)}
          title="Delete"
        >
          <FaTrash size={18} />
        </button>
      </div>
    ),
  },
];

const Testimonial = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    title: "",
    message: "",
    image: null,
    designation: "",
    status: "",
  });

  const { baseUrl } = useBaseUrl();

  // Fetch testimonial data from API
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("action", "get");

      const response = await axios.post(`${baseUrl}testimonial.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });
      console.log("API Response:", response.data);
      if (response.data.status) {
        const testimonials = Object.values(response.data.data || {});
        setTestimonialData(testimonials);
      } else {
        setErrorMessage(response.data.error || "Failed to fetch testimonials.");
      }
    } catch (error) {
      console.error("Axios Error:", error.response || error);
      setErrorMessage(
        "Error connecting to the server. Please check your network or API configuration."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle add testimonial
  const handleAddTestimonial = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    try {
      const data = new FormData();
      data.append("action", "add");
      data.append("name", formData.name);
      data.append("title", formData.title);
      data.append("message", formData.designation);
      data.append("designation", formData.title);
      data.append("message", formData.message);
      data.append("image", formData.image);

      const response = await axios.post(`${baseUrl}testimonial.php`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });
      console.log("Add Response:", response.data);
      if (response.data.status) {
        fetchData();
        setIsAddModalOpen(false);
        setFormData({
          name: "",
          designation: "",
          image: null,
          title: "",
          message: "",
        });
      } else {
        setErrorMessage(response.data.error || "Failed to add testimonial.");
      }
    } catch (error) {
      console.error("Error adding testimonial:", error.response || error);
      setErrorMessage("Failed to add testimonial.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle edit testimonial
  const handleEditTestimonial = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    try {
      const data = new FormData();
      data.append("action", "edit");
      data.append("id", selectedTestimonial.id);
      data.append("name", formData.name);
      data.append("title", formData.title);
      data.append("message", formData.message);
      data.append("designation", formData.designation);
      if (formData.image) data.append("image", formData.image);

      const response = await axios.post(`${baseUrl}testimonial.php`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });
      console.log("Edit Response:", response.data);
      if (response.data.status) {
        fetchData();
        setIsEditModalOpen(false);
        setFormData({
          name: "",
          message: "",
          image: null,
          designation: "",
          title: "",
        });
        alert("Testimonial updated successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to update testimonial.");
      }
    } catch (error) {
      console.error("Error updating testimonial:", error.response || error);
      setErrorMessage("Failed to update testimonial.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle delete action
  const deleteHandler = async (id) => {
    if (window.confirm("Are you sure you want to delete this testimonial?")) {
      try {
        const data = new FormData();
        data.append("action", "delete");
        data.append("id", id);

        const response = await axios.post(`${baseUrl}testimonial.php`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        });
        console.log("Delete Response:", response.data);
        if (response.data.status) {
          setTestimonialData(testimonialData.filter((item) => item.id !== id));
          alert("Testimonial deleted successfully.");
        } else {
          alert(
            "Failed to delete testimonial: " +
              (response.data.error || "Unknown error")
          );
        }
      } catch (error) {
        console.error("Error deleting testimonial:", error.response || error);
        alert("Failed to delete testimonial.");
      }
    }
  };

  // Handle edit action
  const editHandler = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setFormData({
      name: testimonial.name,
      message: testimonial.message,
      title: testimonial.title,
      image: null,
      designation: testimonial.designation,
      status: testimonial.status,
    });
    setIsEditModalOpen(true);
  };

  // Search filter
  const filteredData = testimonialData.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.message?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.designation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.status?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Inject handlers into grid data
  const gridData = filteredData.map((item) => ({
    ...item,
    editHandler,
    deleteHandler,
  }));

  const { setCurrentColor, setCurrentMode, currentMode } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  return (
    <div
      style={currentMode === "Dark" ? { backgroundColor: "#20232A" } : {}}
      className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 animate-fadeIn bg-gray-100 min-h-screen"
    >
      <Header category="Dashboard" title="Testimonial Management" />

      {/* Error Message */}
      {errorMessage && (
        <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-lg flex items-center">
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
          {errorMessage}
        </div>
      )}

      {/* Search and Controls */}
      <div className="mb-6 flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name, message, designation, or status..."
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 bg-white shadow-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="flex gap-2">
          <button
            className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-300 shadow-md"
            onClick={() => {
              setFormData({
                name: "",
                message: "",
                image: null,
                designation: "",
                title: "",
              });
              setIsAddModalOpen(true);
            }}
          >
            <FaPlus className="mr-2" /> Add Testimonial
          </button>
          <button
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 shadow-md disabled:opacity-50"
            onClick={() =>
              document
                .getElementById("testimonialGrid")
                .ej2_instances[0].excelExport()
            }
            disabled={isLoading}
          >
            <FaFileExcel className="mr-2" /> Export Excel
          </button>
          <button
            className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-300 shadow-md disabled:opacity-50"
            onClick={() =>
              document
                .getElementById("testimonialGrid")
                .ej2_instances[0].pdfExport()
            }
            disabled={isLoading}
          >
            <FaFilePdf className="mr-2" /> Export PDF
          </button>
        </div>
      </div>

      {/* Loading Indicator */}
      {isLoading && (
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
        </div>
      )}

      {/* Grid */}
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <GridComponent
          id="testimonialGrid"
          dataSource={gridData}
          allowPaging={true}
          allowSorting={true}
          allowExcelExport={true}
          allowPdfExport={true}
          allowFiltering={true}
          allowResizing={true}
          pageSettings={{ pageSize: 10, pageSizes: [10, 20, 50] }}
          filterSettings={{ type: "Menu", showFilterBarStatus: true }}
        >
          <ColumnsDirective>
            {testimonialGrid.map((item, index) => (
              <ColumnDirective key={index} {...item} />
            ))}
          </ColumnsDirective>
          <Inject
            services={[
              Resize,
              Sort,
              ContextMenu,
              Filter,
              Page,
              ExcelExport,
              PdfExport,
            ]}
          />
        </GridComponent>
      </div>

      {/* Add Testimonial Modal */}
      {isAddModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">
                Add Testimonial
              </h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsAddModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleAddTestimonial} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Title
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Message
                </label>
                <textarea
                  className="w-full p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({ ...formData, message: e.target.value })
                  }
                  rows={4}
                  required
                ></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  onChange={(e) =>
                    setFormData({ ...formData, image: e.target.files[0] })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Designation
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.designation}
                  onChange={(e) =>
                    setFormData({ ...formData, designation: e.target.value })
                  }
                  required
                />
              </div>
              {/* <div>
              <label className="block text-sm font-medium text-gray-700">Status</label>
              <select
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.status}
                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                required
              >
                <option value="">Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div> */}
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition duration-300"
                  onClick={() => setIsAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 disabled:opacity-50"
                  disabled={isLoading}
                >
                  Add Testimonial
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Testimonial Modal */}
      {isEditModalOpen && selectedTestimonial && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-lg">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Edit Testimonial</h2>
              <button
                className="text-gray-600 hover:text-gray-800 transition duration-300"
                title="Close"
                onClick={() => setIsEditModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleEditTestimonial} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Title
                </label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Message
                </label>
                <textarea
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({ ...formData, message: e.target.value })
                  }
                  rows={4}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Image (optional)
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setFormData({ ...formData, image: e.target.files[0] })
                  }
                  className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
                {selectedTestimonial.image && (
                  <img
                    src={selectedTestimonial.image}
                    alt="Current"
                    className="mt-2 w-20 h-20 object-cover rounded-full"
                  />
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Designation
                </label>
                <input
                  type="text"
                  value={formData.designation}
                  onChange={(e) =>
                    setFormData({ ...formData, designation: e.target.value })
                  }
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required
                />
              </div>
              {/* <div>
                <label className="block text-sm font-medium text-gray-700">
                  Status
                </label>
                <select
                  value={formData.status}
                  onChange={(e) =>
                    setFormData({ ...formData, status: e.target.value })
                  }
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div> */}
              <div className="flex justify-end gap-3 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition duration-300"
                  onClick={() => setIsEditModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-300 disabled:opacity-50"
                  disabled={isLoading}
                >
                  Update Testimonial
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Testimonial;
